module.exports = __webpack_public_path__ + "media/bootstrap-icons/border-all-2f808296.svg";